<template>
  <settings-modal class="balance-screenshots-modal t-balance-screenshots-modal">
    <template slot="heading">
      <span>BoL screenshots</span>
      <span class="ml-2">{{ selectedDate }}</span>
      <span class="ml-2">{{ timePeriod[0] }}-{{ timePeriod[1] }}</span>
    </template>

    <div class="balance-screenshots-modal__navigation">
      <div class="balance-screenshots-modal__navigation-list">
        <v-chip
          v-for="(balanceScreenshot, index) in balanceScreenshots"
          :key="index"
          :selected="isSelectedScreenshot(balanceScreenshot)"
          :dark="isSelectedScreenshot(balanceScreenshot)"
          :color="isSelectedScreenshot(balanceScreenshot) ? 'primary' : undefined"
          class="t-screenshot-button"
          @click="() => setSelectedScreenshotIndex(index)"
        >{{ extractTimeFromScreenshot(balanceScreenshot) }}</v-chip>
      </div>
    </div>

    <div class="balance-screenshots-modal__screenshot">
      <div class="balance-screenshots-modal__screenshot-title headline">{{ extractTimeFromScreenshot(balanceScreenshots[selectedScreenshotIndex]) }}</div>
      <v-carousel
        hide-delimiters
        width="auto"
        height="auto"
        :value="selectedScreenshotIndex"
        :cycle="false"
        @input="(index) => setSelectedScreenshotIndex(index)"
      >
        <v-carousel-item
          v-for="(balanceScreenshot, key) in balanceScreenshots"
          :key="key"
        >
          <v-img :src="formatScreenshotUrl(balanceScreenshot)">
            <div
              slot="placeholder"
              class="balance-screenshots-modal__screenshot-loader"
            >
              <v-progress-circular
                indeterminate
                color="primary"
              />
            </div>
          </v-img>
        </v-carousel-item>
      </v-carousel>
    </div>
  </settings-modal>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { AppConfig } from '@/config/config'

  // Mixins
  import form from '@/mixins/form'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'

  export default {
    name: 'BalanceScreenshotsModal',
    components: { SettingsModal },
    mixins: [form],
    data () {
      return {
        selectedScreenshotIndex: 0
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      selectedDate () {
        return this.modal.data.selectedDate
      },
      selectedHour () {
        return this.modal.data.selectedHour
      },
      balanceScreenshots () {
        return this.modal.data.balanceScreenshots
      },
      timePeriod () {
        return [
          String(this.selectedHour),
          String(this.selectedHour + 1)
        ].map(hour => hour.length === 1 ? `0${hour}:00` : `${hour}:00`)
      }
    },
    methods: {
      isSelectedScreenshot (screenshot) {
        return screenshot.path === this.balanceScreenshots[this.selectedScreenshotIndex].path
      },
      formatScreenshotUrl (screenshot) {
        return [
          AppConfig.GATEWAY_SEPA_URL,
          'api/v1/balance-screenshots',
          screenshot.path
        ].join('/')
      },
      setSelectedScreenshotIndex (screenshotIndex) {
        this.$set(this, 'selectedScreenshotIndex', screenshotIndex)
      },
      extractTimeFromScreenshot (screenshot) {
        const [, time] = screenshot.path.split('T')
        return time.slice(0, 8).split('.').join(':')
      }
    }
  }
</script>

<style lang="scss">
  .balance-screenshots-modal {
    .v-window__container,
    .v-carousel__item {
      min-height: 600px;
      height: auto !important;
    }

    .v-chip {
      &__content {
        cursor: pointer;
      }
    }

    &__navigation {
      text-align: center;
      overflow: auto;
      white-space: nowrap;
      margin-bottom: 18px;

      &-list {
        padding: 6px 0 8px;
      }
    }

    &__screenshot {
      position: relative;
      min-height: 300px;

      &-title {
        text-align: center;
        margin-bottom: 10px;
      }

      &-loader {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
      }
    }

    .v-carousel {
      .v-btn {
        color: #888;
      }
    }
  }
</style>
